<template>
  <WdsStack
    direction-column
    align-center
    justify-space-between
    class="tw-bg-white tw-shadow tw-gap-7 tw-p-7.5"
    data-test="no-trusted-contacts-found"
  >
    <slot name="icon">
      <WdsAvatar :path="randomAvatar" xxl></WdsAvatar>
    </slot>
    <div>
      <div class="tw-text-gray-900 tw-font-display tw-text-xl tw-leading-7">
        <slot name="main">{{ $t("We couldn't find a perfect match") }}</slot>
      </div>
      <div class="tw-text-gray-600 tw-font-circular tw-text-lg tw-leading-6">
        <slot name="sub">
          {{ $t('Have someone in-mind? Invite them to your talent pool') }}
        </slot>
      </div>
    </div>
    <WdsStack v-if="!noActions" direction-row justify-space-between align-center class="tw-gap-md">
      <slot name="actions">
        <WdsButton primary :href="laravelNamedRoute(namedRoutes.contacts.index)">
          {{ $t('Invite contact') }}
        </WdsButton>
      </slot>
    </WdsStack>
  </WdsStack>
</template>

<script setup lang="ts">
import { WdsStack, WdsButton, WdsAvatar } from '@worksome/wds-components'
import { getRandomAvatarPath } from '@/utils/avatar'
import { $t } from '@/app-bootstrapping/SetUpInternationalization'
import { laravelNamedRoute } from '@/utils/laravelNamedRoutes'
import namedRoutes from '@/utils/laravelNamedRoutes.json'

const { noActions = false } = defineProps<{ noActions?: boolean }>()

const randomAvatar = getRandomAvatarPath()
</script>

<style scoped lang="scss"></style>
